import React from 'react';
import { ImgLinkProps } from './type/props';
import * as styles from './img-link.module.sass';

export const ImgLink = (props: ImgLinkProps) => {
  return (
    <a href={props.url} className={styles.social_link_container} target={props.target}>
      <img src={props.img} alt={props.alt} />
    </a>
  );
};
